// import "./scss/style.scss";
// import "./scss/css/animate.css";
// import "./scss/css/material-components-web.min.css";
import "./scss/css/animate.scss";
import "./scss/css/Loader.scss";
import "./scss/css/Puzzle.scss";
import "./scss/css/drama.scss";
import "./scss/css/tooltip.scss";
import "./scss/css/draggableModal.scss";
import "./scss/css/extra.scss";
import "./scss/css/editor.scss";

import App from "./js/App.js";
console.warn(document.readyState);
window.onload = () => {
  new App();
};
